<script setup lang="ts">
import { useMigratedSeo } from "~/composables/useMigratedSeo";
import type { LoggedInMemberResponseDto } from "~/resources/useIsnMemberResource";

const layoutResource = useLayoutResource();
const auth = useAuth();

const layoutData = await layoutResource.getLayoutData();

watch( () => auth.isLoggedIn, () => layoutData.refresh() );

const headlessDataState = useHeadlessDataState();

useMigratedSeo( () => headlessDataState.value?.type === "content" ? headlessDataState.value.data : null );

const memberState = useState<LoggedInMemberResponseDto | null | undefined>( "member" );

const updateAcceptedGuidelines = () => {
  if ( memberState.value?.member ) {
    memberState.value.member.acceptedGuidelines = true;
  }
};
</script>

<template>
  <div class="site">
    <apollo-announcements />

    <site-header v-bind="layoutData.data.value" />

    <div
      id="main"
      class="site__content">
      <slot />
    </div>

    <site-footer
      v-bind="layoutData.data.value"
      :has-accepted-guidelines="memberState?.member?.acceptedGuidelines ?? false"
      @accepted-guidelines="updateAcceptedGuidelines" />
  </div>
</template>

<style lang="scss" scoped>
.site {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  &__content {
    flex-grow: 1;
  }
}
</style>
